import { Injectable } from '@angular/core';
import { EKpiGoalsStatusBadge } from '@cta-analytics-dialog/cta-analytics-dialog-content/cta-analytics-table/cta-analytics-details/cta-analytics-details-kpi-goals-table/cta-analytics-details-kpi-goals-table.interface';
import { EAnalyticsStatus, EMatchingType } from '@enums/campaign-analytics.enum';
import { TTileContentStatus } from '@shared/components/social-content-tile/social-content-tile.interface';
import {
  IDeepLinkContentsFilter,
  IDeepLinkDeliverablesFilter,
  IDeepLinkKpiGoalsFilter,
} from './campaign-details-deep-link.interface';

@Injectable()
export class CampaignDetailsDeepLinkService {
  /** Maps circular-graph segment keys → EAnalyticsStatus (for the Deliverables graph) */
  public readonly deliverableSegmentStatusMap: Readonly<Record<string, EAnalyticsStatus>> = {
    failed: EAnalyticsStatus.failed,
    problem: EAnalyticsStatus.problem,
    processing: EAnalyticsStatus.processing,
    success: EAnalyticsStatus.ok,
  };

  /** Maps circular-graph segment keys → EKpiGoalsStatusBadge (for the KPI Goal graph) */
  public readonly kpiGoalSegmentStatusMap: Readonly<Record<string, EKpiGoalsStatusBadge>> = {
    failed: EKpiGoalsStatusBadge.kpiGoalsUnavailable,
    problem: EKpiGoalsStatusBadge.kpiGoalsBelowTarget,
    success: EKpiGoalsStatusBadge.kpiGoalsReached,
  };

  /** Maps circular-graph segment keys → EMatchingType (for the Content Types graph) */
  public readonly contentTypeSegmentMatchingTypeMap: Readonly<Record<string, EMatchingType>> = {
    bonus: EMatchingType.bonus,
    failed: EMatchingType.missing,
    processing: EMatchingType.planned,
    success: EMatchingType.matched,
  };

  public buildContentsFilter(
    revision: number,
    matchingTypes?: Set<EMatchingType>,
    contentStatuses?: Set<TTileContentStatus>,
  ): IDeepLinkContentsFilter {
    return { contentStatuses, matchingTypes, revision };
  }

  public buildDeliverablesFilter(
    revision: number,
    statuses?: Set<EAnalyticsStatus>,
    matchingTypes?: Set<EMatchingType>,
  ): IDeepLinkDeliverablesFilter {
    return { matchingTypes, revision, statuses };
  }

  public buildKpiGoalsFilter(revision: number, statuses?: Set<EKpiGoalsStatusBadge>): IDeepLinkKpiGoalsFilter {
    return { revision, statuses };
  }
}
